import DatePicker from '@/components/date-picker';

import { useField } from 'formik';
import { FC, useCallback } from 'react';
import { useToggle } from 'react-use';

type FormDatePickerProps = {
  className?: string;
  label?: string;
  name: string;
  disabled?: boolean;
};

export const FormDatePicker: FC<FormDatePickerProps> = props => {
  const [isOpen, toggleOpen] = useToggle(false);
  const [{ value }, { error, touched }, helpers] = useField({
    name: props.name
  });

  const onChange = useCallback(({ target }) => {
    helpers.setTouched(true);
    helpers.setValue(target.value);
  }, []);

  return (
    <DatePicker
      disabled={props.disabled}
      error={Boolean(touched && error)}
      errorMessage={touched && error}
      label={props.label}
      name={props.name}
      onChange={onChange}
      onClose={toggleOpen}
      onOpen={toggleOpen}
      open={isOpen}
      value={value}
      variant='outlined'
    />
  );
};
